import {
  Slider as ChakraSlider,
  SliderProps as ChakraSliderProps,
  ComponentWithAs,
  ThemingProps,
} from '@chakra-ui/react';

import { OmitChakraProps } from '../../utils/typeUtils';

export type SliderProps = OmitChakraProps<
  ChakraSliderProps,
  keyof ThemingProps
>;

export const Slider: ComponentWithAs<'div', SliderProps> = ChakraSlider;
